import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  template: `<svg focusable="false" aria-hidden="true" role="img">
              <use xmlns="http://www.w3.org/2000/svg" attr.xlink:href="assets/images/styleguide.svg#{{id}}"></use>
             </svg>`,
  encapsulation: ViewEncapsulation.None
})
export class BscSvgIconComponent {
  @Input() id: string = '';
}
